import activateTab from './activateTab';
import datapoints from '../datapoints';
import getActiveContentTab from '../utils/getActiveContentTab';
import SecondaryReadingPaneTabData from '../store/schema/SecondaryReadingPaneTabData';
import TabViewState, { TabType } from '../store/schema/TabViewState';
import { createLegacyActionWithDatapoint } from 'owa-analytics-actions';
import { getStore } from '../store/tabStore';

let nextId = 1;

export default createLegacyActionWithDatapoint('addTab', datapoints.TabViewAddTab)(function(
    type: TabType,
    isShown: boolean,
    makeActive: boolean,
    data: any
) {
    const currentTab = getActiveContentTab();
    const store = getStore();
    const baseTabViewState = {
        id: TabType[type] + (nextId++).toString(),
        isShown: isShown,
        isActive: false,
        startTime: new Date().getTime(),
        parentTabId: currentTab ? currentTab.id : null,
        blink: isShown, // Set blink to true if the tab is shown. It will be set to false in activateTab() if we want to make active
        data: data,
    };

    // TODO #35453 break addTab into different functions to make it typesafe at the caller
    let tabViewState: TabViewState = null;
    switch (type) {
        case TabType.Primary:
            tabViewState = { ...baseTabViewState, type: TabType.Primary };
            break;
        case TabType.OverflowMenu:
            tabViewState = {
                ...baseTabViewState,
                type: TabType.OverflowMenu,
                data: data as TabViewState[],
            };
            break;
        case TabType.SecondaryReadingPane:
            tabViewState = {
                ...baseTabViewState,
                type: TabType.SecondaryReadingPane,
                data: data as SecondaryReadingPaneTabData,
            };
            break;
        case TabType.Compose:
            tabViewState = { ...baseTabViewState, type: TabType.Compose, data: data as string };
            break;
        case TabType.FloatingChat:
            tabViewState = {
                ...baseTabViewState,
                type: TabType.FloatingChat,
                data: data as string,
                isChatActive: false,
            };
    }

    store.tabs.push(tabViewState);

    if (makeActive) {
        // Use the reference from the store (http://aka.ms/mobx4)
        activateTab(store.tabs[store.tabs.length - 1]);
    }
});
